import { ErrorFillIcon, Text } from '@thefarmersfront/kitchen-mobile';

import { GUIDE_MESSAGES } from '~/constants';

const EmtpyText = ({
  text = GUIDE_MESSAGES.EMPTY_LIST,
  bottomElement,
}: {
  text?: string;
  bottomElement?: React.ReactNode;
}) => {
  const splitText: string[] = String(text).split('\\n') ?? [];

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px' }}
    >
      <ErrorFillIcon size={64} color="gray400" />
      <div>
        {splitText.map((item) => (
          <Text key={item} size="xxlarge" weight="semi-bold" align="center">
            {item}
          </Text>
        ))}
      </div>
      {bottomElement}
    </div>
  );
};

export default EmtpyText;
